import api, {downloadFile, uploadFile} from '@pb/middleware-api';

import getRoot from './getRoot';

export const ROOT = getRoot();

export const API_ROOT = `${ROOT}api/`;

export default api({
    uploadFile,
    downloadFile,
    apiRoot: API_ROOT,
});
